import React, { useEffect, useState } from "react";
import { onAuthChange } from "../services/auth.service.js";
import { getUserOrders } from "../services/order.service.js";
import { Link } from "react-router-dom";

const MyOrders = () => {
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthChange(async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        try {
          const userOrders = await getUserOrders(currentUser.uid);
          setOrders(userOrders);
        } catch (error) {
          console.error("Error fetching orders:", error);
        }
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div className="py-80 text-center">Loading orders...</div>;

  if (!user) {
    return (
      <div className="container py-80 text-center">
        <h5 className="mb-24">Please login to view your orders.</h5>
        <Link to="/account" className="btn btn-main px-40 py-12">Login Now</Link>
      </div>
    );
  }

  return (
    <section className='my-orders py-80'>
      <div className='container container-lg'>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="border border-gray-100 rounded-16 p-32 bg-white shadow-sm">
              <div className="flex-between gap-16 mb-32 flex-wrap">
                <h4 className="mb-0 fw-bold">My Orders</h4>
                <Link to="/shop" className="text-main-600 fw-bold hover-text-main-700">Continue Shopping</Link>
              </div>
              
              {orders.length > 0 ? (
                <div className="table-responsive">
                  <table className="table rounded-12 overflow-hidden border border-gray-100">
                    <thead>
                      <tr className="bg-gray-50 border-bottom border-gray-100">
                        <th className="px-24 py-16 text-md fw-bold">Order ID</th>
                        <th className="px-24 py-16 text-md fw-bold">Date</th>
                        <th className="px-24 py-16 text-md fw-bold">Total</th>
                        <th className="px-24 py-16 text-md fw-bold text-center">Status</th>
                        <th className="px-24 py-16 text-md fw-bold text-end">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.map(order => (
                        <tr key={order.id} className="border-bottom border-gray-50">
                          <td className="px-24 py-20 text-md fw-medium">
                            <span className="text-gray-400">#</span>{order.id.substring(0, 8).toUpperCase()}
                          </td>
                          <td className="px-24 py-20 text-md text-gray-600">
                            {order.createdAt ? new Date(order.createdAt).toLocaleDateString('en-IN', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            }) : 'N/A'}
                          </td>
                          <td className="px-24 py-20 text-md fw-bold text-main-600">
                            Rs.{order.total?.toFixed(0)}
                          </td>
                          <td className="px-24 py-20 text-center">
                            <span className={`badge px-16 py-8 rounded-pill text-xs fw-bold uppercase tracking-wider ${
                              order.status === 'COMPLETED' ? 'bg-success-100 text-success-600' : 
                              order.status === 'CANCELLED' ? 'bg-danger-100 text-danger-600' : 
                              'bg-warning-100 text-warning-600'
                            }`}>
                              {order.status}
                            </span>
                          </td>
                          <td className="px-24 py-20 text-end">
                            <Link to={`/order-details/${order.id}`} className="btn btn-outline-main py-8 px-16 rounded-8 text-xs fw-bold">View Details</Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center py-60 bg-gray-50 rounded-16">
                  <i className="ph ph-package text-6xl text-gray-200 mb-16 d-block"></i>
                  <h5 className="text-gray-500 mb-8">No orders yet</h5>
                  <p className="text-gray-400 mb-24">Looks like you haven't placed any orders yet.</p>
                  <Link to="/shop" className="btn btn-main px-40 py-12">Start Shopping</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyOrders;
